<form [formGroup]="formGroup">
  <div class="d-flex flex-column gap-4">
    <div class="form-grid">
      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="birthdate" i18n>Date of Birth</label>
        <app-datepicker-input
          controlId="birthdate"
          formControlName="birthdate"
          placeholder="dd / mm / yyyy"
          i18n-placeholder
          [error]="formSubmitted && formGroup.controls.birthdate.invalid" />
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.birthdate.invalid"
          [errors]="formGroup.controls.birthdate.errors" />
      </div>

      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="socialInsuranceNumber" i18n>Social Insurance Number</label>
        <app-sin-input
          controlId="socialInsuranceNumber"
          formControlName="socialInsuranceNumber"
          [error]="formSubmitted && formGroup.controls.socialInsuranceNumber.invalid" />
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.socialInsuranceNumber.invalid"
          [errors]="formGroup.controls.socialInsuranceNumber.errors" />
      </div>

      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="genderId" i18n>Gender at Birth</label>
        <app-dropdown-input
          controlId="genderId"
          formControlName="genderId"
          placeholder="Select"
          i18n-placeholder
          [dropdowns]="(genderDropdowns$ | async) ?? []"
          [error]="formSubmitted && formGroup.controls.genderId.invalid" />
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.genderId.invalid"
          [errors]="formGroup.controls.genderId.errors" />
      </div>

      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="pronounId" i18n>Preferred Pronouns</label>
        <app-dropdown-input
          controlId="pronounId"
          formControlName="pronounId"
          placeholder="Select"
          i18n-placeholder
          [clearable]="true"
          [dropdowns]="(pronounDropdowns$ | async) ?? []" />
        <small class="form-input-hint" i18n>Optional</small>
      </div>
    </div>

    <hr class="divider" />

    <ng-content></ng-content>

    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" for="file" i18n>Document</label>
      <app-file-upload-field
        controlId="file"
        formControlName="files"
        [accept]="acceptedFileTypes"
        [multiple]="allowMultipleFiles"
        [maxFileSizeInMb]="maxFileSizeInMb"
        [submitAttempted]="formSubmitted"
        [control]="formGroup.controls.files"
        [showThumbnail]="true">
        <div class="d-flex flex-column align-items-center gap-3" input-copy>
          <img
            src="assets/icons/grey/FileUpload.svg"
            alt="Upload File"
            i18n-alt
            height="24"
            width="24"
            [style.height.rem]="1.5"
            [style.width.rem]="1.5" />
          <app-file-uploader-text
            [disabled]="formGroup.controls.files.disabled"
            descriptionText="or drag and drop .png or .jpeg up to 3MB"
            i18n-descriptionText />
        </div>
      </app-file-upload-field>
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.files.invalid"
        [errors]="formGroup.controls.files.errors"
        [customErrorMessages]="customErrorMessages.files" />
    </div>

    <hr class="mb-3" />
  </div>
</form>
